import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Infrastructure from "./pages/Infrastructure";
import Clients from "./pages/Clients";
import Contact from "./pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
}

function QuoteModal({ isOpen, onClose }) {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-backdrop" onClick={onClose} role="presentation">
      <div
        className="modal-card"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="quote-modal-title"
      >
        <button type="button" className="modal-close" onClick={onClose} aria-label="Close inquiry form">
          x
        </button>
        <p className="eyebrow">Fast Response</p>
        <h2 id="quote-modal-title">Request A Quote</h2>
        <p className="modal-copy">
          Tell us your packaging requirement and our team will connect with you with the right solution.
        </p>
        <form className="quote-form">
          <div className="form-grid">
            <label className="form-field">
              <span>Name</span>
              <input type="text" name="name" placeholder="Your name" />
            </label>
            <label className="form-field">
              <span>Phone</span>
              <input type="tel" name="phone" placeholder="+91" />
            </label>
            <label className="form-field">
              <span>Email</span>
              <input type="email" name="email" placeholder="your@email.com" />
            </label>
            <label className="form-field">
              <span>Product</span>
              <select name="product" defaultValue="Corrugated Boxes">
                <option>Corrugated Boxes</option>
                <option>Angle Boards</option>
                <option>PET Straps</option>
                <option>PP Straps</option>
                <option>BOPP Tapes</option>
                <option>Stretch Film Rolls</option>
                <option>Air Bubble Sheets</option>
                <option>Seals</option>
              </select>
            </label>
          </div>
          <label className="form-field">
            <span>Requirement</span>
            <textarea
              name="message"
              rows="5"
              placeholder="Share dimensions, quantity, industry, or delivery timeline"
            ></textarea>
          </label>
          <button type="submit" className="btn btn-primary form-submit">
            Submit Inquiry
          </button>
        </form>
      </div>
    </div>
  );
}

function App() {
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);

  return (
    <Router>
      <div className="app-shell">
        <ScrollToTop />
        <Navbar onOpenQuote={() => setIsQuoteOpen(true)} />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/infrastructure" element={<Infrastructure />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer onOpenQuote={() => setIsQuoteOpen(true)} />
        <button
          type="button"
          className="whatsapp-float"
          onClick={() => window.open("https://wa.me/919443511714", "_blank", "noopener,noreferrer")}
          aria-label="Chat on WhatsApp"
        >
          WhatsApp
        </button>
        <QuoteModal isOpen={isQuoteOpen} onClose={() => setIsQuoteOpen(false)} />
      </div>
    </Router>
  );
}

export default App;
